import Healthcareimg from '../assets/Healthcare.png';
import Transportationimg from '../assets/Transportation.png';
import Governmentimg from '../assets/Government.png';
import Manufacturingimg from '../assets/Manufacturing.png';
import Logisticsimg from '../assets/Logistics.png';
import EducationImg from '../assets/Education.png';
import Energyimg from '../assets/Energy.png';
import ITImg  from '../assets/IT.png';
import RealEstateImg from '../assets/RealEstate.png';
import RetailImg from '../assets/Retail.png';
export const industriesData = {
  it: {
    id: 'it',
    name: 'IT Assets Management System',
    tagline: 'Simplify, Track, and Optimize Your IT Assets with Intelligent Control',
    location: 'Asset Flow, Pune, India',
    description: 'In today\'s fast-paced digital environment, managing IT assets efficiently is no longer optional—it\'s essential. The IT Assets Management System by Asset Flow is a powerful, scalable solution designed to help organizations monitor, control, and optimize their IT infrastructure seamlessly. Built with modern business needs in mind, it ensures transparency, accountability, and efficiency across the entire asset lifecycle.',
    heroimg: ITImg,
    keyFeatures: [
      {
        id: 1,
        title: 'Centralized Asset Repository',
        description: 'All IT assets—hardware, software, licenses—are stored in one unified system. This eliminates data silos and makes tracking assets across departments simple and efficient.'
      },
      {
        id: 2,
        title: 'Real-Time Asset Tracking',
        description: 'Track asset location, status, and usage in real time. Helps prevent loss, unauthorized usage, and improves accountability.'
      },
      {
        id: 3,
        title: 'Automated Asset Lifecycle Management',
        description: 'From procurement to disposal, every stage is automated. Reduces manual effort and ensures compliance with company policies.'
      },
      {
        id: 4,
        title: 'Barcode / QR Code Integration',
        description: 'Quickly scan and update asset details using barcode or QR code technology. Improves speed and accuracy during audits and asset allocation.'
      },
      {
        id: 5,
        title: 'User & Role Management',
        description: 'Define roles and permissions for employees. Ensures secure access and prevents unauthorized modifications.'
      },
      {
        id: 6,
        title: 'Maintenance & Service Tracking',
        description: 'Schedule maintenance and track service history. Minimizes downtime and extends asset lifespan.'
      },
      {
        id: 7,
        title: 'Cloud-Based Accessibility',
        description: 'Access the system anytime, anywhere. Ideal for remote teams and multi-location businesses.'
      },
      {
        id: 8,
        title: 'Comprehensive Reporting & Analytics',
        description: 'Generate insightful reports on asset usage, depreciation, and performance. Helps management make data-driven decisions.'
      }
    ],

    benefits: [
      {
        id: 1,
        title: 'Improved Asset Visibility',
        description: 'Gain complete transparency over all IT assets. This helps in identifying underutilized resources and optimizing usage.',
        icon: 'FaEye'
      },
      {
        id: 2,
        title: 'Cost Optimization',
        description: 'Avoid unnecessary purchases by tracking existing assets effectively. Reduces wastage and improves ROI.',
        icon: 'FaDollarSign'
      },
      {
        id: 3,
        title: 'Enhanced Security',
        description: 'Monitor asset movement and access. Prevents theft, misuse, and data breaches.',
        icon: 'FaLock'
      },
      {
        id: 4,
        title: 'Increased Operational Efficiency',
        description: 'Automation reduces manual errors and administrative workload. Teams can focus on strategic tasks instead of routine tracking.',
        icon: 'FaBolt'
      },
      {
        id: 5,
        title: 'Regulatory Compliance',
        description: 'Maintain accurate records for audits and compliance requirements. Reduces legal risks and ensures adherence to standards.',
        icon: 'FaCheck'
      },
      {
        id: 6,
        title: 'Better Decision Making',
        description: 'Data-driven insights help management plan future investments. Supports long-term IT strategy.',
        icon: 'FaChartLine'
      }
    ],

    clientReviews: [
      {
        id: 1,
        country: 'USA',
        type: 'IT Consulting Firm',
        review: 'The system streamlined their entire asset tracking process. They reported a 40% reduction in asset misplacement and improved operational clarity.'
      },
      {
        id: 2,
        country: 'UK',
        type: 'Financial Services Company',
        review: 'They appreciated the detailed reporting features. It helped them meet strict compliance requirements effortlessly.'
      },
      {
        id: 3,
        country: 'Canada',
        type: 'Healthcare Organization',
        review: 'Asset Flow improved equipment tracking across multiple facilities. This resulted in faster service response and better patient support.'
      },
      {
        id: 4,
        country: 'Australia',
        type: 'Education Sector',
        review: 'Universities used it to manage thousands of devices. They found the system user-friendly and highly scalable.'
      },
      {
        id: 5,
        country: 'Germany',
        type: 'Manufacturing Company',
        review: 'The lifecycle automation reduced manual workload significantly. They achieved better inventory planning and cost control.'
      },
      {
        id: 6,
        country: 'Singapore',
        type: 'Tech Startup',
        review: 'The cloud-based system enabled remote access and collaboration. Perfect for their distributed workforce.'
      },
      {
        id: 7,
        country: 'UAE',
        type: 'Logistics Company',
        review: 'They praised the QR code feature for quick asset verification. It improved warehouse efficiency and reduced errors.'
      }
    ],

    faqs: [
      {
        id: 1,
        question: 'What is an IT Asset Management System?',
        answer: 'It is a software solution that helps track and manage IT assets throughout their lifecycle.'
      },
      {
        id: 2,
        question: 'Who can use this system?',
        answer: 'Businesses of all sizes—from startups to enterprises—can use it.'
      },
      {
        id: 3,
        question: 'Is it cloud-based?',
        answer: 'Yes, it offers cloud accessibility for remote and multi-location access.'
      },
      {
        id: 4,
        question: 'Can it track both hardware and software?',
        answer: 'Absolutely, it manages both physical and digital assets.'
      },
      {
        id: 5,
        question: 'Does it support barcode scanning?',
        answer: 'Yes, barcode and QR code scanning are supported.'
      },
      {
        id: 6,
        question: 'Is the system customizable?',
        answer: 'Yes, it can be tailored to suit specific business needs.'
      },
      {
        id: 7,
        question: 'How secure is the system?',
        answer: 'It includes role-based access and data encryption for high security.'
      },
      {
        id: 8,
        question: 'Can it generate reports?',
        answer: 'Yes, it provides detailed and customizable reports.'
      },
      {
        id: 9,
        question: 'Does it help in audits?',
        answer: 'Yes, it simplifies audit processes with accurate data records.'
      },
      {
        id: 10,
        question: 'Can multiple users access it?',
        answer: 'Yes, multiple users can access it with defined roles.'
      },
      {
        id: 11,
        question: 'Does it track asset depreciation?',
        answer: 'Yes, it includes depreciation tracking features.'
      },
      {
        id: 12,
        question: 'Is training required?',
        answer: 'Basic training is sufficient due to its user-friendly interface.'
      },
      {
        id: 13,
        question: 'Can it integrate with other systems?',
        answer: 'Yes, it supports integration with ERP and other tools.'
      },
      {
        id: 14,
        question: 'What industries can benefit from it?',
        answer: 'IT, healthcare, education, finance, manufacturing, and more.'
      },
      {
        id: 15,
        question: 'Does it support mobile access?',
        answer: 'Yes, it is accessible via mobile devices.'
      },
      {
        id: 16,
        question: 'Can it send alerts and notifications?',
        answer: 'Yes, for maintenance, expiry, and asset updates.'
      },
      {
        id: 17,
        question: 'How does it reduce costs?',
        answer: 'By preventing duplicate purchases and optimizing asset usage.'
      },
      {
        id: 18,
        question: 'Is customer support available?',
        answer: 'Yes, dedicated support is provided.'
      },
      {
        id: 19,
        question: 'Can it handle large-scale data?',
        answer: 'Yes, it is scalable for enterprise-level data.'
      },
      {
        id: 20,
        question: 'How do I get started?',
        answer: 'You can contact Asset Flow for a demo and onboarding process.'
      }
    ]
  },

  healthcare: {
    id: 'healthcare',
    name: 'Healthcare Assets Management',
    tagline: 'Track Medical Equipment with Precision and Ensure Patient Care Excellence',
    location: 'Global Healthcare Solutions',
    description: 'Healthcare organizations require precise asset tracking for medical equipment, diagnostic devices, and supplies. Asset Flow\'s Healthcare Asset Management System ensures all medical devices are properly maintained, tracked, and accessible when needed. This enhances patient care, improves operational efficiency, and ensures regulatory compliance.',
    heroimg: Healthcareimg,
    keyFeatures: [
      { id: 1, title: 'Medical Equipment Tracking', description: 'Track all medical devices from procurement to end-of-life.' },
      { id: 2, title: 'Maintenance Scheduling', description: 'Automated maintenance alerts for critical medical equipment.' },
      { id: 3, title: 'Regulatory Compliance', description: 'Meet HIPAA and other healthcare regulations.' },
      { id: 4, title: 'Multi-Department Management', description: 'Coordinate assets across multiple departments and facilities.' },
      { id: 5, title: 'Emergency Response', description: 'Quick asset location during medical emergencies.' },
      { id: 6, title: 'Supply Chain Integration', description: 'Track medications and supplies efficiently.' },
      { id: 7, title: 'Usage Analytics', description: 'Analyze equipment usage patterns for optimization.' },
      { id: 8, title: 'Cost Analysis', description: 'Reduce healthcare costs through better asset utilization.' }
    ],

    benefits: [
      { id: 1, title: 'Enhanced Patient Care', description: 'Equipment always available when needed for patient treatment.', icon: 'FaHeartbeat' },
      { id: 2, title: 'Compliance & Safety', description: 'Meet all regulatory requirements and improve safety standards.', icon: 'FaCheck' },
      { id: 3, title: 'Reduced Downtime', description: 'Quick replacements and maintenance prevent service interruptions.', icon: 'FaBolt' },
      { id: 4, title: 'Cost Savings', description: 'Minimize equipment loss and extend asset lifespan.', icon: 'FaDollarSign' },
      { id: 5, title: 'Staff Efficiency', description: 'Less time searching for equipment means more patient care time.', icon: 'FaUsers' },
      { id: 6, title: 'Data Security', description: 'Patient data protected with enterprise-grade security.', icon: 'FaLock' }
    ],

    clientReviews: [
      { id: 1, country: 'USA', type: 'Hospital Network', review: 'Improved patient care by 35% through better equipment availability.' },
      { id: 2, country: 'UK', type: 'Diagnostic Center', review: 'Met all compliance requirements with ease.' },
      { id: 3, country: 'Canada', type: 'Medical Facility', review: 'Reduced equipment loss by 60%.' },
      { id: 4, country: 'Australia', type: 'Clinic Network', review: 'Easy coordination across multiple locations.' },
      { id: 5, country: 'Germany', type: 'Research Hospital', review: 'Excellent analytics and reporting features.' },
      { id: 6, country: 'Singapore', type: 'Healthcare Group', review: 'Perfect for our growing network of facilities.' },
      { id: 7, country: 'India', type: 'Private Hospital', review: 'Significant improvement in operational efficiency.' }
    ],

    faqs: [
      { id: 1, question: 'Is the system HIPAA compliant?', answer: 'Yes, fully compliant with HIPAA and other healthcare regulations.' },
      { id: 2, question: 'Can it track multiple types of equipment?', answer: 'Yes, from diagnostic devices to surgical instruments.' },
      { id: 3, question: 'Does it support maintenance scheduling?', answer: 'Yes, automated maintenance reminders and scheduling.' },
      { id: 4, question: 'Can it integrate with hospital systems?', answer: 'Yes, integrates with EHR and other hospital management systems.' },
      { id: 5, question: 'Is data backup available?', answer: 'Yes, automatic daily backups ensure data safety.' },
      { id: 6, question: 'Can it handle emergency situations?', answer: 'Yes, quick asset location features for emergencies.' },
      { id: 7, question: 'What about patient data privacy?', answer: 'Strict access controls and encryption protect all patient data.' },
      { id: 8, question: 'Is mobile access available?', answer: 'Yes, mobile app for on-the-go asset tracking.' }
    ]
  },

  manufacturing: {
    id: 'manufacturing',
    name: 'Manufacturing Assets Management',
    tagline: 'Optimize Production Through Intelligent Asset Lifecycle Management',
    location: 'Industrial Asset Solutions',
    description: 'Manufacturing facilities need seamless asset management to ensure production continuity and minimize downtime. Asset Flow\'s Manufacturing Solution tracks machinery, tools, and equipment throughout their lifecycle, enabling predictive maintenance and operational excellence.',
    heroimg: Manufacturingimg,
    keyFeatures: [
      { id: 1, title: 'Machinery Tracking', description: 'Real-time monitoring of all production equipment.' },
      { id: 2, title: 'Predictive Maintenance', description: 'AI-powered maintenance alerts prevent breakdowns.' },
      { id: 3, title: 'Production Line Optimization', description: 'Track assets across production lines for efficiency.' },
      { id: 4, title: 'Tool Management', description: 'Track and manage tools and small equipment.' },
      { id: 5, title: 'Work Order Integration', description: 'Automatic work order generation for maintenance.' },
      { id: 6, title: 'Asset Performance Metrics', description: 'Detailed analytics on equipment performance.' },
      { id: 7, title: 'Supplier Integration', description: 'Seamless communication with spare parts suppliers.' },
      { id: 8, title: 'Compliance Tracking', description: 'Ensure equipment meets safety and quality standards.' }
    ],

    benefits: [
      { id: 1, title: 'Reduced Downtime', description: 'Preventive maintenance keeps production running.', icon: 'FaClock' },
      { id: 2, title: 'Cost Efficiency', description: 'Lower maintenance costs through predictive insights.', icon: 'FaDollarSign' },
      { id: 3, title: 'Increased Productivity', description: 'Better asset utilization improves output.', icon: 'FaChartLine' },
      { id: 4, title: 'Improved Safety', description: 'Regular monitoring ensures equipment safety compliance.', icon: 'FaShield' },
      { id: 5, title: 'Supply Chain Optimization', description: 'Efficient spare parts management saves time.', icon: 'FaTools' },
      { id: 6, title: 'Data-Driven Decisions', description: 'Analytics help optimize production planning.', icon: 'FaChartLine' }
    ],

    clientReviews: [
      { id: 1, country: 'USA', type: 'Automotive Plant', review: 'Reduced downtime by 45% and increased production efficiency.' },
      { id: 2, country: 'Germany', type: 'Precision Manufacturing', review: 'Excellent equipment monitoring and maintenance planning.' },
      { id: 3, country: 'Japan', type: 'Electronics Manufacturer', review: 'Perfect integration with existing systems.' },
      { id: 4, country: 'South Korea', type: 'Chemical Plant', review: 'Superior safety tracking capabilities.' },
      { id: 5, country: 'India', type: 'Textile Mill', review: 'Significant cost savings through predictive maintenance.' },
      { id: 6, country: 'China', type: 'Steel Manufacturing', review: 'Excellent scalability for large operations.' },
      { id: 7, country: 'Brazil', type: 'Industrial Facility', review: 'Great support team and regular updates.' }
    ],

    faqs: [
      { id: 1, question: 'Does it offer predictive maintenance?', answer: 'Yes, AI-powered predictive maintenance alerts.' },
      { id: 2, question: 'Can it track All equipment types?', answer: 'Yes, machinery, tools, and small equipment.' },
      { id: 3, question: 'Is real-time tracking available?', answer: 'Yes, real-time monitoring of all assets.' },
      { id: 4, question: 'Does it integrate with ERP systems?', answer: 'Yes, integrates with popular ERP solutions.' },
      { id: 5, question: 'What about IoT sensor support?', answer: 'Yes, supports IoT devices for advanced tracking.' },
      { id: 6, question: 'Can it generate compliance reports?', answer: 'Yes, automated compliance reporting.' },
      { id: 7, question: 'Is mobile access available?', answer: 'Yes, mobile app for shop floor management.' },
      { id: 8, question: 'How does it help with spare parts management?', answer: 'Automatic spare parts tracking and supplier integration.' }
    ]
  },

  retail: {
    id: 'retail',
    name: 'Retail Assets Management',
    tagline: 'Streamline Inventory and Store Equipment Management Across All Locations',
    location: 'Omnichannel Retail Solutions',
    description: 'Retail businesses with multiple stores require efficient asset management to track inventory, POS systems, and store equipment. Asset Flow provides a unified platform for managing assets across all retail locations.',
    heroimg: RetailImg,
    keyFeatures: [
      { id: 1, title: 'Multi-Store Inventory Tracking', description: 'Unified view of inventory across all locations.' },
      { id: 2, title: 'POS System Management', description: 'Track and manage all point-of-sale equipment.' },
      { id: 3, title: 'Shelf-Ready Inventory', description: 'Real-time stock visibility and shelf optimization.' },
      { id: 4, title: 'Store Equipment Tracking', description: 'Monitor all store fixtures and equipment.' },
      { id: 5, title: 'Loss Prevention', description: 'Alerts for theft and unauthorized movement.' },
      { id: 6, title: 'Supplier Management', description: 'Seamless supplier communication for restocking.' },
      { id: 7, title: 'Sales Analytics', description: 'Asset performance data linked to sales.' },
      { id: 8, title: 'Mobile Checkout', description: 'Portable asset tracking for retail associates.' }
    ],

    benefits: [
      { id: 1, title: 'Reduced Shrinkage', description: 'Better loss prevention and inventory accuracy.', icon: 'FaMinusCircle' },
      { id: 2, title: 'Improved Availability', description: 'Products always available when customers want them.', icon: 'FaCheck' },
      { id: 3, title: 'Fast Restocking', description: 'Quick inventory management saves time.', icon: 'FaBolt' },
      { id: 4, title: 'Better Customer Experience', description: 'Well-stocked shelves and faster checkout.', icon: 'FaSmile' },
      { id: 5, title: 'Omnichannel Support', description: 'Unified asset view across online and offline.', icon: 'FaShoppingCart' },
      { id: 6, title: 'Labor Efficiency', description: 'Less time searching for items and equipment.', icon: 'FaUsers' }
    ],

    clientReviews: [
      { id: 1, country: 'USA', type: 'Retail Chain', review: 'Reduced out-of-stock situations by 50%.' },
      { id: 2, country: 'UK', type: 'Department Store', review: 'Excellent multi-store coordination.' },
      { id: 3, country: 'Canada', type: 'Specialty Retailer', review: 'Great mobile tracking features.' },
      { id: 4, country: 'Australia', type: 'Shopping Mall Retailers', review: 'Perfect for managing multiple locations.' },
      { id: 5, country: 'France', type: 'Fashion Retailer', review: 'Improved inventory accuracy significantly.' },
      { id: 6, country: 'Germany', type: 'Electronics Store', review: 'Excellent for high-value item tracking.' },
      { id: 7, country: 'Japan', type: 'Convenience Store Chain', review: 'Reduced shrinkage by 40%.' }
    ],

    faqs: [
      { id: 1, question: 'Can it handle multi-store operations?', answer: 'Yes, unified management for all store locations.' },
      { id: 2, question: 'Does it prevent theft?', answer: 'Yes, with alerts for unauthorized movement.' },
      { id: 3, question: 'Is real-time inventory visible?', answer: 'Yes, real-time stock updates across all stores.' },
      { id: 4, question: 'Does it support e-commerce?', answer: 'Yes, omnichannel support for online and offline.' },
      { id: 5, question: 'Can it track POS systems?', answer: 'Yes, complete POS management and tracking.' },
      { id: 6, question: 'Is mobile access available?', answer: 'Yes, mobile app for retail associates.' },
      { id: 7, question: 'What about supplier integration?', answer: 'Yes, automatic restocking and reorder management.' },
      { id: 8, question: 'Can it generate sales reports?', answer: 'Yes, linked asset-to-sales reporting.' }
    ]
  },

  education: {
    id: 'education',
    name: 'Education Assets Management',
    tagline: 'Manage School and University Resources Efficiently for Better Learning Outcomes',
    location: 'Educational Institution Solutions',
    description: 'Educational institutions need to manage diverse assets—from computers and laboratory equipment to furniture and learning materials. Asset Flow helps schools and universities maintain their resources effectively.',
    heroimg: EducationImg,
    keyFeatures: [
      { id: 1, title: 'Laboratory Equipment Tracking', description: 'Track all lab equipment and maintain safety.' },
      { id: 2, title: 'Computer Lab Management', description: 'Manage computers and IT equipment across campus.' },
      { id: 3, title: 'Library Resources Tracking', description: 'Track books, equipment, and digital resources.' },
      { id: 4, title: 'Furniture Management', description: 'Monitor classroom and office furniture.' },
      { id: 5, title: 'Sports Equipment Tracking', description: 'Track athletic and recreational equipment.' },
      { id: 6, title: 'Multi-Department Coordination', description: 'Manage assets across departments and buildings.' },
      { id: 7, title: 'Damage & Maintenance Logs', description: 'Track equipment damage and maintenance needs.' },
      { id: 8, title: 'Audit Reports', description: 'Generate detailed audit reports for institutional compliance.' }
    ],

    benefits: [
      { id: 1, title: 'Better Learning Environment', description: 'Well-maintained equipment improves education quality.', icon: 'FaGraduationCap' },
      { id: 2, title: 'Cost Control', description: 'Reduce asset waste and unnecessary replacements.', icon: 'FaDollarSign' },
      { id: 3, title: 'Student & Staff Safety', description: 'Properly maintained equipment ensures safety.', icon: 'FaShield' },
      { id: 4, title: 'Accountability', description: 'Clear tracking improves institutional responsibility.', icon: 'FaCheck' },
      { id: 5, title: 'Regulatory Compliance', description: 'Meet accreditation and audit requirements.', icon: 'FaCheck' },
      { id: 6, title: 'Efficient Resource Sharing', description: 'Easy sharing of resources across departments.', icon: 'FaUsers' }
    ],

    clientReviews: [
      { id: 1, country: 'USA', type: 'University', review: 'Excellent for managing campus-wide resources.' },
      { id: 2, country: 'UK', type: 'School Network', review: 'Great for coordinating multiple school locations.' },
      { id: 3, country: 'Canada', type: 'College', review: 'Reduced equipment damage by 35%.' },
      { id: 4, country: 'Australia', type: 'University', review: 'Perfect for laboratory equipment tracking.' },
      { id: 5, country: 'India', type: 'Educational Institution', review: 'Great value for money and excellent support.' },
      { id: 6, country: 'Singapore', type: 'School', review: 'Easy to use and very effective.' },
      { id: 7, country: 'Germany', type: 'University', review: 'Excellent compliance and audit features.' }
    ],

    faqs: [
      { id: 1, question: 'Can it track laboratory equipment?', answer: 'Yes, with safety compliance tracking.' },
      { id: 2, question: 'Does it work for multiple campuses?', answer: 'Yes, perfect for multi-location institutions.' },
      { id: 3, question: 'Can teachers access the system?', answer: 'Yes, role-based access for staff.' },
      { id: 4, question: 'Is it suitable for schools?', answer: 'Yes, designed for K-12 and higher education.' },
      { id: 5, question: 'Can it track library resources?', answer: 'Yes, books and digital resources tracking.' },
      { id: 6, question: 'Does it help with audits?', answer: 'Yes, generates compliance audit reports.' },
      { id: 7, question: 'Is mobile access available?', answer: 'Yes, convenient mobile app for faculty.' },
      { id: 8, question: 'Can it track sports equipment?', answer: 'Yes, athletic and recreational equipment.' }
    ]
  },

  realestate: {
    id: 'realestate',
    name: 'Real Estate Assets Management',
    tagline: 'Efficiently Manage Property Assets and Maintenance from One Platform',
    location: 'Property Management Solutions',
    description: 'Real estate companies and property management firms need comprehensive asset tracking for buildings, equipment, and fixtures. Asset Flow\'s Real Estate Solution streamlines property maintenance, improves tenant satisfaction, and ensures regulatory compliance.',
    heroimg: RealEstateImg,
    keyFeatures: [
      { id: 1, title: 'Property Asset Tracking', description: 'Track all building equipment and fixtures.' },
      { id: 2, title: 'Maintenance Scheduling', description: 'Automated maintenance alerts for HVAC, plumbing, etc.' },
      { id: 3, title: 'Tenant Interaction Portal', description: 'Tenants can submit maintenance requests easily.' },
      { id: 4, title: 'Multi-Property Management', description: 'Manage multiple properties from one dashboard.' },
      { id: 5, title: 'Lease Tracking', description: 'Automated lease expiry and renewal alerts.' },
      { id: 6, title: 'Emergency Response', description: 'Quick response to emergency maintenance needs.' },
      { id: 7, title: 'Cost Analysis', description: 'Detailed reports on maintenance and repair costs.' },
      { id: 8, title: 'Compliance Documentation', description: 'Maintain compliance records automatically.' }
    ],

    benefits: [
      { id: 1, title: 'Tenant Satisfaction', description: 'Faster maintenance response improves satisfaction.', icon: 'FaSmile' },
      { id: 2, title: 'Reduced Vacancy', description: 'Well-maintained properties attract tenants.', icon: 'FaBuilding' },
      { id: 3, title: 'Cost Savings', description: 'Preventive maintenance reduces emergency expenses.', icon: 'FaDollarSign' },
      { id: 4, title: 'Compliance Assurance', description: 'Automatic compliance documentation.', icon: 'FaCheck' },
      { id: 5, title: 'Efficient Operations', description: 'Streamlined property management processes.', icon: 'FaBolt' },
      { id: 6, title: 'Better ROI', description: 'Optimized operations improve property value.', icon: 'FaChartLine' }
    ],

    clientReviews: [
      { id: 1, country: 'USA', type: 'Property Management Company', review: 'Tenant satisfaction increased by 40%.' },
      { id: 2, country: 'UK', type: 'Real Estate Group', review: 'Excellent multi-property management capabilities.' },
      { id: 3, country: 'Canada', type: 'Property Developer', review: 'Great maintenance scheduling features.' },
      { id: 4, country: 'Australia', type: 'Apartment Complex Management', review: 'Reduced maintenance costs significantly.' },
      { id: 5, country: 'UAE', type: 'Real Estate Company', review: 'Perfect for managing large portfolios.' },
      { id: 6, country: 'Singapore', type: 'Property Manager', review: 'Excellent tenant communication features.' },
      { id: 7, country: 'Hong Kong', type: 'Real Estate Investment', review: 'Very effective property tracking system.' }
    ],

    faqs: [
      { id: 1, question: 'Can it manage multiple properties?', answer: 'Yes, unified dashboard for all properties.' },
      { id: 2, question: 'Do tenants get a portal?', answer: 'Yes, dedicated tenant portal for requests.' },
      { id: 3, question: 'Can it schedule maintenance?', answer: 'Yes, automated maintenance scheduling.' },
      { id: 4, question: 'Does it track lease information?', answer: 'Yes, lease management and renewal tracking.' },
      { id: 5, question: 'What about emergency repairs?', answer: 'Yes, priority handling for emergencies.' },
      { id: 6, question: 'Can it generate expense reports?', answer: 'Yes, detailed cost and expense reports.' },
      { id: 7, question: 'Is mobile access available?', answer: 'Yes, property managers can work on the go.' },
      { id: 8, question: 'How does it help with compliance?', answer: 'Automatic documentation for regulatory compliance.' }
    ]
  },

  transportation: {
    id: 'transportation',
    name: 'Transportation Assets Management',
    tagline: 'Track Vehicles and Equipment to Maximize Fleet Efficiency and Safety',
    location: 'Fleet Management Solutions',
    description: 'Transportation companies need real-time tracking of vehicles, equipment, and fuel usage. Asset Flow\'s Transportation Solution provides comprehensive fleet management to reduce costs and improve safety.',
    heroimg: Transportationimg,
    keyFeatures: [
      { id: 1, title: 'Vehicle Tracking', description: 'Real-time GPS tracking of all vehicles.' },
      { id: 2, title: 'Maintenance Management', description: 'Automated maintenance schedules and reminders.' },
      { id: 3, title: 'Fuel Management', description: 'Track fuel consumption and costs.' },
      { id: 4, title: 'Driver Management', description: 'Monitor driver behavior and safety.' },
      { id: 5, title: 'Route Optimization', description: 'Optimize routes to reduce fuel and time.' },
      { id: 6, title: 'Equipment Tracking', description: 'Track trailers and cargo equipment.' },
      { id: 7, title: 'Compliance Reporting', description: 'Automatic DOT and safety compliance reports.' },
      { id: 8, title: 'Mobile Driver App', description: 'Drivers access assignments and log hours.' }
    ],

    benefits: [
      { id: 1, title: 'Reduced Costs', description: 'Lower fuel and maintenance expenses.', icon: 'FaDollarSign' },
      { id: 2, title: 'Improved Safety', description: 'Better driver behavior monitoring.', icon: 'FaShield' },
      { id: 3, title: 'Faster Delivery', description: 'Optimized routing reduces delivery times.', icon: 'FaBolt' },
      { id: 4, title: 'Fleet Reliability', description: 'Preventive maintenance increases uptime.', icon: 'FaTruck' },
      { id: 5, title: 'Compliance Ready', description: 'Automatic regulatory compliance.', icon: 'FaCheck' },
      { id: 6, title: 'Customer Satisfaction', description: 'On-time delivery and real-time tracking updates.', icon: 'FaSmile' }
    ],

    clientReviews: [
      { id: 1, country: 'USA', type: 'Trucking Company', review: 'Reduced fleet costs by 35%.' },
      { id: 2, country: 'Canada', type: 'Delivery Service', review: 'Excellent real-time tracking.' },
      { id: 3, country: 'UK', type: 'Logistics Provider', review: 'Great driver safety features.' },
      { id: 4, country: 'Australia', type: 'Transport Company', review: 'Improved efficiency significantly.' },
      { id: 5, country: 'Germany', type: 'Fleet Manager', review: 'Perfect maintenance scheduling.' },
      { id: 6, country: 'France', type: 'Delivery Fleet', review: 'Excellent fuel management insights.' },
      { id: 7, country: 'Spain', type: 'Transport Business', review: 'Great value and wonderful support.' }
    ],

    faqs: [
      { id: 1, question: 'Is GPS tracking available?', answer: 'Yes, real-time GPS tracking for all vehicles.' },
      { id: 2, question: 'Can it track fuel usage?', answer: 'Yes, detailed fuel consumption tracking.' },
      { id: 3, question: 'Does it offer route optimization?', answer: 'Yes, AI-powered route optimization.' },
      { id: 4, question: 'Is driver monitoring included?', answer: 'Yes, driver behavior and safety monitoring.' },
      { id: 5, question: 'Does it track maintenance?', answer: 'Yes, automated maintenance scheduling.' },
      { id: 6, question: 'Can drivers access it?', answer: 'Yes, mobile app for drivers.' },
      { id: 7, question: 'What about compliance?', answer: 'Yes, automatic DOT and safety reporting.' },
      { id: 8, question: 'Does it track trailers?', answer: 'Yes, equipment and trailer tracking.' }
    ]
  },

  logistics: {
    id: 'logistics',
    name: 'Logistics Assets Management',
    tagline: 'Streamline Warehouse Operations and Inventory Management with Real-Time Visibility',
    location: 'Supply Chain Solutions',
    description: 'Logistics companies require comprehensive asset management for warehouses, storage equipment, and inventory. Asset Flow provides complete visibility into warehouse operations and supply chain management.',
    heroimg: Logisticsimg,
    keyFeatures: [
      { id: 1, title: 'Warehouse Equipment Tracking', description: 'Track forklifts, pallet jacks, and racks.' },
      { id: 2, title: 'Inventory Management', description: 'Real-time inventory and location tracking.' },
      { id: 3, title: 'Storage Space Optimization', description: 'Maximize warehouse utilization.' },
      { id: 4, title: 'Shipment Tracking', description: 'Track shipments from warehouse to delivery.' },
      { id: 5, title: 'Equipment Maintenance', description: 'Preventive maintenance for warehouse equipment.' },
      { id: 6, title: 'Worker Management', description: 'Track worker assignments and productivity.' },
      { id: 7, title: 'Integration with Carriers', description: 'Seamless carrier and shipping integration.' },
      { id: 8, title: 'Analytics & Reporting', description: 'Supply chain analytics and insights.' }
    ],

    benefits: [
      { id: 1, title: 'Faster Operations', description: 'Quicker order processing and fulfillment.', icon: 'FaBolt' },
      { id: 2, title: 'Reduced Errors', description: 'Fewer shipping and inventory mistakes.', icon: 'FaCheck' },
      { id: 3, title: 'Cost Savings', description: 'Better space utilization and equipment use.', icon: 'FaDollarSign' },
      { id: 4, title: 'Improved Tracking', description: 'Real-time shipment and inventory visibility.', icon: 'FaBox' },
      { id: 5, title: 'Customer Satisfaction', description: 'Faster and more accurate deliveries.', icon: 'FaSmile' },
      { id: 6, title: 'Scalability', description: 'Supports growing warehouse operations.', icon: 'FaChartLine' }
    ],

    clientReviews: [
      { id: 1, country: 'USA', type: 'Warehouse Operator', review: 'Processing capacity increased by 50%.' },
      { id: 2, country: 'China', type: 'Logistics Provider', review: 'Excellent inventory tracking.' },
      { id: 3, country: 'Japan', type: 'Distribution Center', review: 'Great for large-scale operations.' },
      { id: 4, country: 'Singapore', type: 'Port Authority', review: 'Perfect for container tracking.' },
      { id: 5, country: 'Dubai', type: 'Logistics Company', review: 'Reduced errors by 60%.' },
      { id: 6, country: 'Netherlands', type: 'Distribution Hub', review: 'Excellent European supply chain integration.' },
      { id: 7, country: 'India', type: 'Logistics Provider', review: 'Great scalability and affordable pricing.' }
    ],

    faqs: [
      { id: 1, question: 'Can it track warehouse equipment?', answer: 'Yes, all equipment and machinery.' },
      { id: 2, question: 'Does it provide inventory tracking?', answer: 'Yes, real-time inventory and locations.' },
      { id: 3, question: 'Can it optimize storage space?', answer: 'Yes, with storage utilization analytics.' },
      { id: 4, question: 'Does it track shipments?', answer: 'Yes, from warehouse to final delivery.' },
      { id: 5, question: 'Can it integrate with carriers?', answer: 'Yes, integration with major carriers.' },
      { id: 6, question: 'Does it provide analytics?', answer: 'Yes, detailed supply chain analytics.' },
      { id: 7, question: 'Is it scalable?', answer: 'Yes, supports operations of any size.' },
      { id: 8, question: 'Can it track workers?', answer: 'Yes, track worker assignments and productivity.' }
    ]
  },

  government: {
    id: 'government',
    name: 'Government Assets Management',
    tagline: 'Maintain Accountability and Transparency in Public Asset Management',
    location: 'Public Sector Solutions',
    description: 'Government agencies need transparent asset management systems for public accountability. Asset Flow\'s Government Solution ensures proper tracking and reporting of public assets in compliance with regulations.',
    heroimg: Governmentimg,
    keyFeatures: [
      { id: 1, title: 'Asset Accountability', description: 'Full audit trail for all government assets.' },
      { id: 2, title: 'Compliance Reporting', description: 'Automatic compliance with regulations.' },
      { id: 3, title: 'Multi-Department Coordination', description: 'Manage assets across departments.' },
      { id: 4, title: 'Budget Tracking', description: 'Track asset acquisition and maintenance budgets.' },
      { id: 5, title: 'Public Records', description: 'Transparent records for public access.' },
      { id: 6, title: 'Audit Support', description: 'Generate comprehensive audit reports.' },
      { id: 7, title: 'Security & Access Control', description: 'Role-based access with audit logging.' },
      { id: 8, title: 'Lifecycle Management', description: 'Track assets from procurement to disposal.' }
    ],

    benefits: [
      { id: 1, title: 'Public Accountability', description: 'Transparent asset management improves public trust.', icon: 'FaChartLine' },
      { id: 2, title: 'Compliance Assurance', description: 'Meet all regulatory and audit requirements.', icon: 'FaCheck' },
      { id: 3, title: 'Cost Control', description: 'Better budget management and cost tracking.', icon: 'FaDollarSign' },
      { id: 4, title: 'Efficiency', description: 'Streamlined asset and budget processes.', icon: 'FaBolt' },
      { id: 5, title: 'Risk Mitigation', description: 'Reduce misuse and unauthorized access.', icon: 'FaShield' },
      { id: 6, title: 'Data Security', description: 'Government-grade security standards.', icon: 'FaLock' }
    ],

    clientReviews: [
      { id: 1, country: 'USA', type: 'Federal Agency', review: 'Excellent compliance and audit features.' },
      { id: 2, country: 'Canada', type: 'Provincial Government', review: 'Great multi-department coordination.' },
      { id: 3, country: 'UK', type: 'Local Authority', review: 'Improved public transparency.' },
      { id: 4, country: 'Australia', type: 'Government Department', review: 'Perfect for asset accountability.' },
      { id: 5, country: 'Singapore', type: 'City Government', review: 'Excellent system for public sector.' },
      { id: 6, country: 'India', type: 'Government Ministry', review: 'Great value for taxpayer funds.' },
      { id: 7, country: 'South Africa', type: 'Government Agency', review: 'Improved efficiency and transparency.' }
    ],

    faqs: [
      { id: 1, question: 'Is it compliant with regulations?', answer: 'Yes, built for government compliance.' },
      { id: 2, question: 'Can multiple departments use it?', answer: 'Yes, multi-department coordination.' },
      { id: 3, question: 'Does it provide audit trails?', answer: 'Yes, complete audit trail for all actions.' },
      { id: 4, question: 'Is it secure?', answer: 'Yes, government-grade security.' },
      { id: 5, question: 'Can it track budgets?', answer: 'Yes, asset and budget tracking.' },
      { id: 6, question: 'Is data accessible to public?', answer: 'Yes, transparency with controlled access.' },
      { id: 7, question: 'Does it generate audit reports?', answer: 'Yes, comprehensive audit reporting.' },
      { id: 8, question: 'Can it track asset lifecycle?', answer: 'Yes, from purchase to disposal.' }
    ]
  },

  energy: {
    id: 'energy',
    name: 'Energy & Utilities Assets Management',
    tagline: 'Optimize Operations and Ensure Safety Across Energy Infrastructure',
    location: 'Energy Sector Solutions',
    description: 'Energy and utilities companies need comprehensive asset management for power generation, distribution, and infrastructure. Asset Flow helps manage equipment, ensure maintenance compliance, and optimize operations.',
    heroimg: Energyimg,
    keyFeatures: [
      { id: 1, title: 'Infrastructure Asset Tracking', description: 'Track power plants, substations, transformers.' },
      { id: 2, title: 'Maintenance Management', description: 'Critical maintenance scheduling and alerts.' },
      { id: 3, title: 'Safety Compliance', description: 'Safety protocols and compliance tracking.' },
      { id: 4, title: 'Work Order Management', description: 'Automated work order generation and tracking.' },
      { id: 5, title: 'Spare Parts Inventory', description: 'Optimize spare parts and materials.' },
      { id: 6, title: 'Performance Monitoring', description: 'Real-time equipment performance monitoring.' },
      { id: 7, title: 'Emergency Response', description: 'Quick response for emergency situations.' },
      { id: 8, title: 'Regulatory Compliance', description: 'Meet NERC, FERC, and other regulations.' }
    ],

    benefits: [
      { id: 1, title: 'Reduced Downtime', description: 'Predictive maintenance prevents outages.', icon: 'FaBolt' },
      { id: 2, title: 'Enhanced Safety', description: 'Compliance and safety protocols ensure worker safety.', icon: 'FaShield' },
      { id: 3, title: 'Cost Optimization', description: 'Better resource and spare parts management.', icon: 'FaDollarSign' },
      { id: 4, title: 'Operational Efficiency', description: 'Streamlined maintenance and operations.', icon: 'FaCogs' },
      { id: 5, title: 'Regulatory Compliance', description: 'Meet all regulatory requirements.', icon: 'FaCheck' },
      { id: 6, title: 'Reliability', description: 'Improved grid and equipment reliability.', icon: 'FaChartLine' }
    ],

    clientReviews: [
      { id: 1, country: 'USA', type: 'Power Utility', review: 'Reduced outages by 40%.' },
      { id: 2, country: 'Germany', type: 'Energy Company', review: 'Excellent for renewable energy tracking.' },
      { id: 3, country: 'Canada', type: 'Utility Provider', review: 'Great maintenance management system.' },
      { id: 4, country: 'Australia', type: 'Power Provider', review: 'Perfect for large infrastructure management.' },
      { id: 5, country: 'UAE', type: 'Energy Authority', review: 'Excellent compliance features.' },
      { id: 6, country: 'Brazil', type: 'Energy Utility', review: 'Great for hydroelectric facility management.' },
      { id: 7, country: 'Saudi Arabia', type: 'Oil & Gas Company', review: 'Superior asset lifecycle management.' }
    ],

    faqs: [
      { id: 1, question: 'Can it track power infrastructure?', answer: 'Yes, all power generation and distribution assets.' },
      { id: 2, question: 'Does it offer predictive maintenance?', answer: 'Yes, AI-powered predictive maintenance.' },
      { id: 3, question: 'Is it compliant with energy regulations?', answer: 'Yes, NERC, FERC, and other regulations.' },
      { id: 4, question: 'Can it monitor performance?', answer: 'Yes, real-time performance monitoring.' },
      { id: 5, question: 'Does it manage spare parts?', answer: 'Yes, inventory and supply chain management.' },
      { id: 6, question: 'What about emergency response?', answer: 'Yes, quick emergency alert systems.' },
      { id: 7, question: 'Can it generate compliance reports?', answer: 'Yes, automated regulatory reporting.' },
      { id: 8, question: 'Is it scalable for large operations?', answer: 'Yes, designed for enterprise-scale operations.' }
    ]
  }
};

export default industriesData;
